<div class="gup-C-inputCounter">

    <ng-content></ng-content>

    <kal-icon (click)="up()"
              class="gup-C-inputCounter__up"
              [class.-disabled]="disabled">keyboard_arrow_up
    </kal-icon>
    <kal-icon (click)="down()"
              class="gup-C-inputCounter__down"
              [class.-disabled]="disabled">keyboard_arrow_down
    </kal-icon>
</div>


